import { render, staticRenderFns } from "./stage2step2.vue?vue&type=template&id=5d86dbc8&"
import script from "./stage2step2.vue?vue&type=script&lang=js&"
export * from "./stage2step2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports